import { Component, OnInit, Input } from '@angular/core';
import { AdminService } from '../../services/admin';
import { Router } from '@angular/router';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    test : Date = new Date();
    @Input() getFooter: boolean;
    constructor(private adminService: AdminService,private router: Router) { }

    ngOnInit() {}




logout() {
    let a= null;
    let b= null;
    console.log("fafana ny cache............")
    this.adminService.setUserIscrit(a,b);
    this.adminService.setUserloginUserCMS(a,b);
    this.router.navigate(['/index']);    
     //this.router.navigate(['/login']);    
}

}
